/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loading[_ngcontent-%COMP%]{opacity:.3;pointer-events:none}.green-background[_ngcontent-%COMP%]{background-color:#a0c13a!important}"];
export { styles as styles };
//# sourceMappingURL=industry-content-tile.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/industry-content-tile/industry-content-tile.component.scss.shim.ngstyle.js
// module id = 1591
// module chunks = 27 28 29